module.exports = __webpack_public_path__ + "media/images/spotlight-bg-fc46d3d8b752d18ee1082d4fa46a15a8.jpg";